// https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript

type ErrorWithMessage = {
  message: string;
};

type ErrorWithMessageAndStack = ErrorWithMessage & {
  stack?: string;
};

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  );
}

function isErrorWithMessageAndStack(
  error: unknown,
): error is ErrorWithMessageAndStack {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    'stack' in error &&
    typeof (error as Record<string, unknown>).message === 'string' &&
    typeof (error as Record<string, unknown>).stack === 'string'
  );
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}

function toErrorWithMessageAndStack(
  maybeError: unknown,
): ErrorWithMessageAndStack {
  if (isErrorWithMessageAndStack(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}

export function getErrorMessage(error: unknown) {
  return toErrorWithMessage(error).message;
}

export function getErrorStack(error: unknown) {
  return toErrorWithMessageAndStack(error).stack ?? '';
}
